module.exports = __webpack_public_path__ + "img/aws.259e1339.svg";